import ApexCharts from 'apexcharts';
if (typeof window !== 'undefined') {
  window.ApexCharts = ApexCharts;
}
export default ApexCharts;
